import { graphql } from '@teachino/shared-infrastructure';

export const updateMaterialMutation = graphql(`
  mutation UpdateMaterial(
    $id: String!
    $name: String
    $icon: String
    $duration: Float
    $contentHtml: MaterialContentHtmlInput
  ) {
    updateMaterial(
      updateMaterialInput: {
        id: $id
        name: $name
        icon: $icon
        duration: $duration
        contentHtml: $contentHtml
      }
    ) {
      __typename
    }
  }
`);
